import { callApi } from '../../libs'
// import getBookingQueue from './getBookingQueue'

const getBookingForm = async (id) => {
    return new Promise(async (resolve, reject) => {
        const url = `${process.env.REACT_APP_API_COVID19}/api/bookings/history`
        const method = 'post'
        const body = {
            userID: id
        }
        try {
            const response = await callApi(method, url, body, null)
            // console.log(response)
            // let tickets = response.data
            resolve(response)
        } catch (error) {
            reject(error)
        }
    })
}

export default getBookingForm